import { Injectable } from '@angular/core';
import { NetworkService } from '../infrastructure/network.service';
import { ConfigService } from '../infrastructure/config.service';
import { saveAs } from 'file-saver';

@Injectable()
export class SubscriptionManagementService {
  constructor(public configService: ConfigService, public networkService: NetworkService) { }

  // Convert b64 to BLOB
  public b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    b64Data = b64Data.replace(/\s/g, ''); // IE compatibility...
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  // Decode base64 to file
  public base64toFile(base64String, contentType, fileName) {
    const blob = this.b64toBlob(base64String, contentType, 550);
    saveAs(blob, fileName);
  }

  // Get Landing page  data
  public getLandingGridList(filters) {
    return this.networkService.postRequest(this.configService.getSubscriptionMgmtGridListUrl(), filters);
  }

  // Save subscription
  public saveSubscriptions(data) {
    return this.networkService.postRequest(this.configService.saveSubscriptionListUrl(), data);
  }

  public checkManageSubAvailibility() {
    return this.networkService.getRequest(this.configService.checkManageSubAvailibility());
  }

  public getSubscriptionDataForExport(filters) {
    return this.networkService.postRequest(this.configService.getSubscriptionDataForExport(), filters);
  }

  // Get Subscriptions list
  public getSubscriptionsList(userRoleList) {
    return this.networkService.postRequest(this.configService.getSubscriptionsListUrl(), userRoleList);
  }

  // Get Subscriptions for single account
  public getSubscriptionForAccount(filters) {
    return this.networkService.postRequest(this.configService.getSubscriptionForAccountUrl(), filters);
  }

  // Get Subscroiption Roles List

  public getSubscriptionRoleList() {
    return this.networkService.getRequest(this.configService.getRoleListUrl());
  }
  // Get Subscription Type List

  public getSubscriptionTypeList() {
    return this.networkService.getRequest(this.configService.getSubscriptionTypeListUrl());
  }
}
